import { request, success, failure } from 'app/actions';
import * as actions from './networkPanelActions';
import { resolveNetworkPanelSsoUrl } from './networkPanelHelpers';

const initialState = {
  networkPanelSSOUrl: null,
  loadingNetworkPanelSSO: false,
  networkPanelSSOUrlFetched: false,
  networkPanelSSOError: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_NETWORK_PANEL_SSO_URL):
      return {
        ...state,
        networkPanelSSOUrl: initialState.networkPanelSSOUrl,
        loadingNetworkPanelSSO: true,
        networkPanelSSOError: false,
      };
    case success(actions.GET_NETWORK_PANEL_SSO_URL): {
      const networkPanelSSOUrl = resolveNetworkPanelSsoUrl(action.payload.content);
      return {
        ...state,
        networkPanelSSOUrl,
        loadingNetworkPanelSSO: false,
        networkPanelSSOUrlFetched: true,
        networkPanelSSOError: !networkPanelSSOUrl,
      };
    }
    case failure(actions.GET_NETWORK_PANEL_SSO_URL):
      return {
        ...state,
        networkPanelSSOUrl: initialState.networkPanelSSOUrl,
        loadingNetworkPanelSSO: false,
        networkPanelSSOUrlFetched: true,
        networkPanelSSOError: true,
      };
    default:
      return state;
  }
};

export default reducer;
